<template>
  <BaseFieldWrapper
    v-bind="{...$props, ...$attrs}"
    v-on="$listeners"

    v-slot="{vuelidateIns, value, listeners, ske, attrs}"
  >
    <slot></slot>

    <input ref="input"
      :value="value"
      :class="[vuelidateIns && 'border-danger', warning && 'border-warning']"

      v-bind="attrs"
      v-on="listeners"
      :autocomplete="autocomplete"

      class="form-control"
    >

    <slot name="after"></slot>
  </BaseFieldWrapper>
</template>

<script>

import BaseFieldWrapper, { props } from "./FormFieldWrapper.vue"

export default {
  props: {
    ...props,

    focus: Boolean,
    autocomplete: String,
  },
  components: {
    BaseFieldWrapper,
  },
  mounted() {
    if (this.focus) {
      this.$refs.input.focus()
    }
  },
}

</script>

<style scoped>

/* input {
  border: 1px solid #bebfc1;
} */

</style>
